module.exports = __webpack_public_path__ + "static/img/a3.c4a79d6f.jpg";